import React, {useState,} from "react"
import Icon from "../../common/icon/icon.component.jsx"
import {DebounceInput} from "react-debounce-input"
import AuthService from "../../state/auth/AuthService"
import {isError} from "../../state/helpers/Error"
import Passwordstrengthbar from "./PasswordStrengthBar"

type Props = {
    placeholder: string,
    value: string,
    inputName: string,
    required: boolean,
    handleFormChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    handlePasswordScoreChange: (isAcceptable: boolean) => void
}


function PasswordStrengthVerificationInput(props: Props) {
    const [inputElement, setInputElement] = useState({type: "password", icon: "eye-slash"})
    const [passwordScore, setPasswordScore] = useState(0)

    const changeVisibility = () => {
        if (inputElement.type == "password") {
            setInputElement({type: "text", icon: "eye"})
        } else {
            setInputElement({type: "password", icon: "eye-slash"})
        }
    }

    const handlePasswordStrengthChange = (event) => {
        if (event.target.value != "") {
            AuthService.GetPasswordStrength(event.target.value).then(res => {
                if (!isError(res)) {
                    setPasswordScore(res.getScore())
                    props.handlePasswordScoreChange(res.isAcceptable())
                }
            })
        } else {
            setPasswordScore(0)
        }
        props.handleFormChange(event)
    }


    return (
        <div>
            <div className="input-group align-items-center">
                <DebounceInput
                    name={props.inputName}
                    minLength={0}
                    debounceTimeout={500}
                    onChange={handlePasswordStrengthChange}
                    value={props.value}
                    type={inputElement.type}
                    placeholder={props.placeholder}
                    className="form-control py-2 border-right-0 border"
                    required={props.required}
                />
                <span className="input-group-append">
                    <button className="btn btn-outline-secondary border-left-0 border" onClick={() => changeVisibility()}
                        type="button">
                        <Icon value={inputElement.icon}></Icon>
                    </button>
                </span>
            </div>
            <Passwordstrengthbar score={passwordScore}/>
        </div>
    )
}

export default PasswordStrengthVerificationInput


// WEBPACK FOOTER //
// ./src/user/form/PasswordStrengthVerificationInput.tsx